type RichTextNode = {
  text?: string;
  type?: string;
  children?: RichTextNode[];
};

const MEDIA_NODE_TYPES = new Set(["image", "video"]);

function nodeHasContent(node: RichTextNode | null | undefined): boolean {
  if (!node) {
    return false;
  }

  if (typeof node.text === "string" && node.text.trim().length > 0) {
    return true;
  }

  if (typeof node.type === "string" && MEDIA_NODE_TYPES.has(node.type)) {
    return true;
  }

  if (Array.isArray(node.children)) {
    return node.children.some((child) => nodeHasContent(child));
  }

  return false;
}

const buildParagraphRichText = (text: string): string =>
  JSON.stringify([
    {
      type: "paragraph",
      children: [{ text }],
    },
  ]);

export function getCalendarAccessibilityRichText(
  accessibility?: string | null
): string | null {
  const normalizedAccessibility = accessibility?.trim();

  if (!normalizedAccessibility) {
    return null;
  }

  try {
    const parsed = JSON.parse(normalizedAccessibility) as unknown;

    if (Array.isArray(parsed)) {
      return parsed.some((node) => nodeHasContent(node as RichTextNode))
        ? normalizedAccessibility
        : null;
    }

    if (typeof parsed === "string") {
      const plainTextValue = parsed.trim();
      return plainTextValue ? buildParagraphRichText(plainTextValue) : null;
    }

    return buildParagraphRichText(normalizedAccessibility);
  } catch {
    return buildParagraphRichText(normalizedAccessibility);
  }
}

export function hasCalendarAccessibilityContent(
  accessibility?: string | null
): boolean {
  return !!getCalendarAccessibilityRichText(accessibility);
}

export function getCalendarLocationMapsUrl(
  location?: string | null,
  options?: {
    latitude?: number | null;
    longitude?: number | null;
  }
): string | null {
  const normalizedLocation = location?.trim();

  if (
    typeof options?.latitude === "number" &&
    typeof options?.longitude === "number"
  ) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      `${options.latitude},${options.longitude}`
    )}`;
  }

  if (!normalizedLocation) {
    return null;
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(normalizedLocation)}`;
}
